import { pipe } from 'fp-ts/function';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { commanderForm, validation, FileForm, fileFormConstraints } from '@mews-commander/legacy-form';
import { CommanderSidebar } from '../../../components/sidebar';

export default pipe(
    FileForm,
    commanderForm({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Upload} />,
        validate: validation(fileFormConstraints),
        submitButtonProps: { variant: 'primary' },
    }),
    CommanderSidebar
);
